// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__njkQq","primary":"Heading_primary__oizDv","secondary":"Heading_secondary__2_7qv"};